import React from "react";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { FlexRow } from "components/flex-box";
import { Paragraph } from "components/Typography";
import {
  Container,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import JobTitleCard from "components/card/JobOpeningCard";
import BazarImage from "components/BazarImage";

const jobPositions = [
  // {
  //   title: "Senior Accounting Staff",
  //   department: "Accounting Department",
  //   isAvailable: true,
  // },
  {
    title: "Office Staff",
    department: "-",
    isAvailable: true,
  },
  {
    title: "Accounting Staff",
    department: "Accounting Department",
    isAvailable: true,
  },
  {
    title: "Marketing Associate",
    department: "Marketing Department",
    isAvailable: true,
  },
  {
    title: "Cashier",
    department: "Accounting Department",
    isAvailable: true,
  },
  // {
  //   title: "Warehouse Associate",
  //   department: "Warehouse Department",
  //   isAvailable: true,
  // },
];

const Careers: React.FC = () => {
  const [selectedPosition, setSelectedPosition] = React.useState<string>();

  const handleApply = (positionTitle: string) => {
    setSelectedPosition(positionTitle);
  };

  const handleEmail = () => {
    window.location.href = `mailto:hr@pcworth.com?subject=Application for ${selectedPosition}`;
    setSelectedPosition("");
  };

  const handleClose = () => {
    setSelectedPosition('');
  };

  return (
    <ShopLayout1 title="Careers" navbar={<Navbar />}>
      <BazarImage
        alt="career"
        src={"/assets/images/banners/career.png"}
        sx={{ width: "100%", mt: 2 }}
      />
      <Container maxWidth="md" sx={{ p: 2, mb: 5 }}>
        <FlexRow mt={5}>
          <Paragraph sx={{ ml: 1, textAlign: "center", fontSize: "1.1rem" }}>
            The PC Worth invites talented individuals passionate about
            technology and gaming to explore exciting job opportunities in a
            fast-paced, innovative environment.
          </Paragraph>
        </FlexRow>
      </Container>

      <Container>
        <Grid container spacing={2}>
          {jobPositions.map((job) => (
            <Grid item xs={12} sm={6} md={4} key={job.title}>
              <JobTitleCard
                job={job} // Pass the entire job object
                onApply={() => handleApply(job.title)}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Dialog confirmation */}
      <Dialog
        open={selectedPosition ? true : false}
        onClose={handleClose}
        PaperProps={{
          sx: {
            maxWidth: 400,
            width: "100%",
            margin: "0 auto",
            boxShadow: 3,
            padding: 2,
            backgroundColor: "white",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "1.25rem",
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          Confirm Application
        </DialogTitle>
        <Paragraph
          sx={{ textAlign: "center", fontSize: "1.1rem", margin: "16px 0" }}
        >
          <strong>Applying For:</strong> {selectedPosition}
        </Paragraph>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 16px",
          }}
        >
          <Button
            onClick={handleEmail}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#cf181f",
              "&:hover": { backgroundColor: "#b3161a" },
              width: "48%",
              borderRadius: "20px",
            }}
          >
            Open Email
          </Button>
          <Button
            onClick={handleClose}
            color="secondary"
            variant="outlined"
            sx={{
              width: "48%",
              borderRadius: "20px",
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </ShopLayout1>
  );
};

export default Careers;
